import { Locale } from "@dealer-center/ddc-core-utils";
import { pagePadding } from "../styles/constants";
import styled from "styled-components";

const StyledContainer = styled.div`
  ${pagePadding}
`;

const CenteredContent = styled.div`
  text-align: center;
`;

const ContentHeader = styled.h1`
  text-align: center;
`;

const ContentText = styled.p``;

export const ControlCenterIncompletePath = () => {
  return (
    <StyledContainer>
      <CenteredContent>
        <ContentHeader>
          {Locale.getText("WERE_SORRY_SOMETHING_WENT_WRONG")}
        </ContentHeader>
        <ContentText>{Locale.getText("PAGE_DOESNT_EXIST")}</ContentText>
      </CenteredContent>
    </StyledContainer>
  );
};
